import React, { useState } from 'react'
import 'styles/AddActivityModal.css'
import { getOnChangeFunction } from 'utils'
import ButtonComponent from 'components/common/ButtonComponent'

const AddActivityModal = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    activityName: '',
    allDevices: false,
    shared: false
  })

  const onChange = getOnChangeFunction(setFormData, formData)

  return (
    <div className='add-activity-modal-overlay'>
      <div className='add-activity-modal'>
        <div className='pb-3'>
          <h3 className='text-lg font-semibold text-greenPrimary'>Create Activity</h3>
        </div>
        <div className='form-group'>
          <label>Activity Name *</label>
          <input
            type='text'
            name='activityName'
            value={formData.activityName}
            onChange={onChange}
            required
          />
        </div>
        <div className='checkbox-group'>
          <label>
            <input
              type='checkbox'
              name='allDevices'
              checked={formData.allDevices}
              onChange={onChange}
            />
            All Devices
          </label>
          <label>
            <input
              type='checkbox'
              name='shared'
              checked={formData.shared}
              onChange={onChange}
            />
            Shared
          </label>
        </div>
        <div className='flex justify-end space-x-4 mt-4'>
          <ButtonComponent onClick={onClose} customColorsStyles='bg-gray-100 text-greenPrimary hover:text-white'>
            Cancel
          </ButtonComponent>
          <ButtonComponent onClick={() => onSave(formData)}>
            Save
          </ButtonComponent>
        </div>
      </div>
    </div>
  )
}

export default AddActivityModal
